import * as React from 'react';
import { useState } from 'react';
import SearchScreen from '../SearchScreen';
import { Button, Overlay } from '../common';
import SearchOverlayProps from './type';
import './styles.scss';

const SearchOverlay = ({
  title,
  appId,
  publicKey,
  searchIndex,
  eventsMoreLink,
  newsMoreLink,
}: SearchOverlayProps) => {
  const [isActive, setIsActive] = useState<boolean>(false);

  return (
    <>
      <Button
        type="button"
        icon={{
          reference: '#icon-search',
          title,
        }}
        handleClick={() => setIsActive(!isActive)}
      />
      {isActive && (
        <Overlay handleClose={() => setIsActive(false)} containerLess>
          <SearchScreen
            title="test"
            appId={appId}
            publicKey={publicKey}
            searchIndex={searchIndex}
            eventsMoreLink={eventsMoreLink}
            newsMoreLink={newsMoreLink}
          />
        </Overlay>
      )}
    </>

  );
};

export default SearchOverlay;
